export default __webpack_public_path__ + "static/chocolatebarfi-54d4bc7e0b5012e4398789e80c914b8a.png";